import { isObject, isNil } from 'lodash';
import { isImmutable, get } from 'immutable';

/* eslint-disable-next-line import/prefer-default-export */
export function maybeTranslate(value, intl) {
  if (isNil(value)) {
    return value;
  }

  if (isObject(value)) {
    let id;
    if (isImmutable(value)) {
      id = get(value, 'translationId');
    } else {
      // @ts-expect-error TS(2339): Property 'translationId' does not exist on type 'o... Remove this comment to see the full error message
      id = value.translationId;
    }
    return intl.formatMessage({ id });
  }

  return value;
}
